import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overview-commissions',
  templateUrl: './overview-commissions.component.html',
  styleUrls: ['./overview-commissions.component.scss'],
})
export class OverviewCommissionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
